import about from '/src/assets/about-alternative.png';

function About() {

  return (
    <section
      id='about'
      data-section='about'
      className='scroll-m-20 mx-auto w-full md:max-w-2xl lg:max-w-4xl container section undefined'>
      <h2 className='flex items-center gap-x-3 mb-6 font-semibold text-3xl dark:text-white text'>
        <svg className='size-8' width='24' height='24' viewBox='0 0 24 24' strokeWidth='2' stroke='currentColor' fill='none' strokeLinecap='round' strokeLinejoin='round'>
          <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
          <path d='M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0'></path>
          <path d='M6 21v-2a4 4 0 0 1 4 -4h4'></path>
          <path d='M15 19l2 2l4 -4'></path>
        </svg>
        About me
      </h2>
      <article className='flex md:flex-row flex-col justify-center items-center gap-8 text'>
        <div className='[&>p]:mb-4 [&>p>strong]:text-accent [&>p>strong]:font-normal [&>p>strong]:font-mono text-pretty order-2 md:order-1'>
          <p>
            I am a Java Developer and Programmer Analyst student from
            Montevideo, Uruguay, specialized in backend development with strong
            frontend analysis. I have experience with technologies such as
            React, PostgreSQL, MongoDB, and more. Since Oct 2025, I work as a
            Backend Developer at <strong>Antel</strong>, through the consulting
            firm <strong>Epidata S.A</strong>, where I mainly use Java and Spring Boot.
          </p>
        </div>
        <img width={200} height={200} src={about} alt='Carlos Barbieri' loading='lazy' decoding='async' className='order-1 md:order-2 bg-black/20 dark:bg-yellow-500/5 p-1 lg:p-2 rounded-2xl ring-1 ring-black/70 dark:ring-white/20 w-64 lg:w-64 h-full font-onest aspect-square object-cover [object-position:50%_24%] md:[object-position:50%_28%] brightness-100 contrast-105 saturate-95 hue-rotate-[-6deg] dark:brightness-110 dark:contrast-110 dark:saturate-80 dark:hue-rotate-[-16deg] rotate-3' />
      </article>
    </section>
  )
}

export default About;
